import React, { FC } from 'react'
import { connect } from 'react-redux'
import { beforeLoanVisa, view as eventView } from '../../../../store/event'
import { LKButton } from 'loankeeper-common/components'
import LKModal, { actions as LKModalActions } from '../../../shared/LKModal'
import { actions as DCActions } from '../../../DetailsContainer'
import translate, { translateLKMessage } from '../../translator'
import ClientValidationResults from '../../../shared/Modals/ClientValidationResults'
import { useCallbackInstance } from '../../../../hooks'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'src/store/index.d'

import { VisaLoanButtonProps } from '../../types.LoanDetails'
import { loanVisa } from 'src/store/loan'

const VisaLoanButton: FC<VisaLoanButtonProps> = (props) => {
  const {
    type,
    ID,
    hash,
    disabled,
    clientID,
    clientHash,
    openModal,
    openConfirmation,
    openError,
    fetchPage,
    beforeLoanVisa,
    eventView,
  } = props

  const [loading, setLoading] = React.useState(false)
  const sessionRef = React.useRef<{
    isResubmit?: boolean
    WHLSessionID?: any
    HashSum_WHLSessionID_?: any
    ErrorLevel?: any
  }>({ isResubmit: false })

  const dispatch = useDispatch<AppDispatch>()

  const onClick = React.useCallback(() => {
    openConfirmation('LoanVisaConfirm')
  }, [openConfirmation])

  const onConfirm = useCallbackInstance(async () => {
    setLoading(true)

    try {
      if (!sessionRef.current.isResubmit) {
        const { ErrorLevel, WHLSessionID, HashSum_WHLSessionID_ } = (
          await beforeLoanVisa({
            AMLOperTypeID: 31,
            ClientID: clientID,
            HashSum_ClientID_: clientHash,
            LoanID: ID,
            HashSum_LoanID_: hash,
          })
        ).payload

        sessionRef.current = { WHLSessionID, HashSum_WHLSessionID_, ErrorLevel }

        if (ErrorLevel === 150 || ErrorLevel === 200) {
          const { payload: Data } = await eventView({ WHLSessionID, HashSum_WHLSessionID_ })

          openModal({
            name: ErrorLevel === 150 ? 'ClientValidationResultsConfirm' : 'ClientValidationResults',
            Data,
            ErrorLevel,
          })

          return
        }
      } else {
        sessionRef.current.isResubmit = false
      }

      const { WHLSessionID, HashSum_WHLSessionID_ } = sessionRef.current
      // await Loan.loanOper({ LoanID: ID, HashSum_LoanID_: hash, page: 'visa', WHLSessionID, HashSum_WHLSessionID_ })

      //UPDATED API REQUEST loan_oper_api page: visa
      const response = await dispatch(
        loanVisa({
          LoanID: ID,
          HashSum_LoanID_: hash,
          WHLSessionID,
          HashSum_WHLSessionID_,
        }),
      )

      if (!loanVisa.fulfilled.match(response)) {
        throw { Error: { Message: response.payload } }
      }

      fetchPage(type, ID, hash)
    } catch (error) {
      openError(translateLKMessage(error.Error.Message || error.Error.Text))
    } finally {
      setLoading(false)
    }
  })

  return (
    <>
      {/* @ts-ignore */}
      <LKModal.Confirmation name="LoanVisaConfirm" loading={loading} onConfirm={onConfirm} />

      <ClientValidationResults
        name="ClientValidationResultsConfirm"
        onClose={() => {
          openConfirmation('CONFIRM_MATRIX_WARNING', {
            message: translateLKMessage('CONFIRM_VALIDATION_WARNING_OVERRIDE'),
          })
        }}
      />
      {/* @ts-ignore */}
      <LKModal.Confirmation
        name="CONFIRM_MATRIX_WARNING"
        onConfirm={() => {
          sessionRef.current.isResubmit = true
          onConfirm()
        }}
      />
      {/* @ts-ignore */}
      <LKButton onClick={onClick} disabled={disabled} style={{ marginBottom: 5 }} alias="bullet_green">
        {translate('cmd_visa')}
      </LKButton>
    </>
  )
}

export default connect(undefined, {
  openModal: LKModalActions.open,
  openConfirmation: LKModalActions.openConfirmation,
  openError: LKModalActions.openError,
  fetchPage: (type: string, ID: string, hash: string) => DCActions.fetchPage({ type, ID, hash, page: 'base' }),
  beforeLoanVisa,
  eventView,
  //@ts-ignore
})(VisaLoanButton)
